import type { AbilityDef } from "../../sim";

/**
 * «Бег назад»: ← ← — разворот и бег от соперника, в конце разворот лицом к нему (клип Running To Turn, Джон 04.11.2026,
 * 22:29). Третий ← в окне — невидимка ← ← ← (касания не забываются); с 6-го кадра бег прерывается любым приёмом.
 * Ход — назад от соперника, по 5 px за кадр, к развороту гаснет: стопы бегут вместе с миром.
 */
const RUN = 30;
const BRAKE = 12;
export const BACK_RUN: AbilityDef = {
  id: "back-run",
  name: "Бег назад",
  input: { gesture: ["B", "B"] },
  pose: "backRun",
  startup: RUN + BRAKE + 8,
  active: 0,
  recovery: 0,
  keepTaps: true,
  cancelFrom: 6,
  motion: [
    ...Array.from({ length: RUN }, () => -5),
    ...Array.from({ length: BRAKE }, (_, index) => -5 * (1 - (index + 1) / BRAKE)),
  ],
};
